<script setup lang="ts">
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSnackbarQueue } from '@/composables/useSnackbarQueue'

defineOptions({ render: () => null })

const route = useRoute()
const router = useRouter()
const { enqueue } = useSnackbarQueue()

watch(
  () => route.query.error,
  (error) => {
    if (error !== 'access_denied') return

    enqueue({
      text: 'That page is for grown-ups. Back to your chores!',
      variant: 'blocked',
      action: { label: 'OK', handler: () => {} },
      testId: 'access-denied-snackbar',
    })
    const query = Object.fromEntries(
      Object.entries(route.query).filter(([key]) => key !== 'error')
    )
    void router.replace({ path: route.path, query, hash: route.hash })
  },
  { immediate: true }
)
</script>
